import { useModal } from "@/common/contexts/Modal.context";
import { Button } from "antd";
import { useNavigate } from "react-router";

export default function GoToPageButton({
  link,
  destinationName,
}: {
  link: string;
  destinationName: string;
}) {
  const navigate = useNavigate();
  const { closeModal } = useModal();
  const onPageClick = () => {
    navigate(link);
    closeModal();
  };
  return (
    <Button
      type="primary"
      className="h-10 text-inter font-semibold text-base"
      onClick={onPageClick}
    >
      {destinationName}
    </Button>
  );
}
